import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import { ContactPage } from "@mui/icons-material";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout")),
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));

const AddAdmin = Loadable(
  lazy(() => import("../pages/admins/admins/AddAdmin")),
);
// const Dashboard = Loadable(lazy(() => import("../pages/dashboard/Dashboard")));

const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view")),
);
const AddPrivilegs = Loadable(
  lazy(() => import("../pages/admins/privileges/AddPrivilegs")),
);

const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login")),
);
const CountriesPage = Loadable(lazy(() => import("../pages/countries/View")));
const AddCountriesPage = Loadable(
  lazy(() => import("../pages/countries/AddCountries")),
);
const SlideShowPage = Loadable(lazy(() => import("../pages/slide_show/View")));
const AddSlideShowPage = Loadable(
  lazy(() => import("../pages/slide_show/AddSlideShow")),
);

const ServicesPage = Loadable(lazy(() => import("../pages/services/View")));
const AddServicesPage = Loadable(
  lazy(() => import("../pages/services/AddServices")),
);

const SubServicesPage = Loadable(
  lazy(() => import("../pages/sub_services/View")),
);
const AddSubServicesPage = Loadable(
  lazy(() => import("../pages/sub_services/AddSubServices")),
);

const SubServicesMainPage = Loadable(
  lazy(() => import("../pages/sub_services_main/View")),
);
const AddSubServicesMainPage = Loadable(
  lazy(() => import("../pages/sub_services_main/AddSubServicesMain")),
);

const SubServicesListingPage = Loadable(
  lazy(() => import("../pages/sub_services_listing/View")),
);
const AddSubServicesListingPage = Loadable(
  lazy(() => import("../pages/sub_services_listing/AddSubServicesListing")),
);

const IndustriesPage = Loadable(lazy(() => import("../pages/industries/View")));
const AddIndustriesPage = Loadable(
  lazy(() => import("../pages/industries/AddIndustries")),
);

const IndustriesDetailsPage = Loadable(
  lazy(() => import("../pages/industries_details/View")),
);
const AddIndustriesDetailsPage = Loadable(
  lazy(() => import("../pages/industries_details/AddIndustriesDetails")),
);

const NextLinkPage = Loadable(lazy(() => import("../pages/next_link/View")));
const AddNextLinkPage = Loadable(
  lazy(() => import("../pages/next_link/AddNextLink")),
);

const TrustedByPage = Loadable(lazy(() => import("../pages/trusted_by/View")));
const AddTrustedByPage = Loadable(
  lazy(() => import("../pages/trusted_by/AddTrustedBy")),
);

const OurClientsPage = Loadable(
  lazy(() => import("../pages/our_clients/View")),
);
const AddOurClientsPage = Loadable(
  lazy(() => import("../pages/our_clients/AddOurClients")),
);

const NewsPage = Loadable(lazy(() => import("../pages/news/View")));
const AddNewsPage = Loadable(lazy(() => import("../pages/news/AddNews")));

const AddSettings = Loadable(
  lazy(() => import("../pages/settings/AddSettings")),
);

const StatsInfoPage = Loadable(lazy(() => import("../pages/stats_info/View")));

const AddStats = Loadable(lazy(() => import("../pages/stats_info/AddStats")));

const WorkDiversityPage = Loadable(
  lazy(() => import("../pages/work_diversity/View")),
);
const AddWorkDiversityPage = Loadable(
  lazy(() => import("../pages/work_diversity/AddWorkDiversity")),
);

const CSRProjectsPage = Loadable(
  lazy(() => import("../pages/csr_projects/View")),
);
const AddCSRProjectsPage = Loadable(
  lazy(() => import("../pages/csr_projects/AddCSRProjects")),
);

const ValuesPage = Loadable(lazy(() => import("../pages/values/View")));
const AddValuesPage = Loadable(lazy(() => import("../pages/values/AddValues")));

const SeoPage = Loadable(lazy(() => import("../pages/seo/View")));
const AddSeoPage = Loadable(lazy(() => import("../pages/seo/AddSeo")));
const WorkWIthUsPage = Loadable(
  lazy(() => import("../pages/work-with-us/WorkWIthUsPage")),
);
const DiscoverNextLinkPage = Loadable(
  lazy(() => import("../pages/discover_nextlink/DiscoverNextLinkPage")),
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance")),
);

const AddInnovation = Loadable(
  lazy(() => import("../pages/innovation/InnovationPage")),
);

const AddAbout = Loadable(lazy(() => import("../pages/about/AboutPage")));

const AddCEO = Loadable(lazy(() => import("../pages/CEO/AddCEO")));

const AddPolicies = Loadable(
  lazy(() => import("../pages/Policies/AddPolicies")),
);

const ViewAwardsPage = Loadable(
  lazy(() => import("../pages/awards/view-awards")),
);
const AddAwardsPage = Loadable(
  lazy(() => import("../pages/awards/add-awards")),
);
const AwardsTypePage = Loadable(
  lazy(() => import("../pages/awards/awards-type")),
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      // {
      //   path: "/dashboards",
      //   exact: true,
      //   element: <Dashboard />,
      // },
      data["69e866133634bde6f1b39c0e"]?.access_read === 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["69e866133634bde6f1b39c0e"]?.access_read === 1 && {
        path: RouterName.workWithUs.workWithUs,
        exact: true,
        element: <WorkWIthUsPage />,
      },
      data["69e866133634bde6f1b39c0e"]?.access_read === 1 && {
        path: RouterName.discoverNextlink.discoverNextlink,
        exact: true,
        element: <DiscoverNextLinkPage />,
      },
      (data["69e866133634bde6f1b39c0e"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0e"]?.access_edit === 1) && {
        path: `${RouterName.admins.addAdmins}/:id?`,
        exact: true,
        element: <AddAdmin />,
      },
      data["69e866133634bde6f1b39c0e"]?.access_read === 1 && {
        path: `${RouterName.privileges.privileges}`,
        exact: true,
        element: <PrivilegesPage />,
      },
      (data["69e866133634bde6f1b39c0e"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0e"]?.access_edit === 1) && {
        path: `${RouterName.privileges.addPrivileges}/:id?`,
        exact: true,
        element: <AddPrivilegs />,
      },

      data["69e866133634bde6f1b39c14"]?.access_read === 1 && {
        path: `${RouterName.countries.countries}`,
        exact: true,
        element: <CountriesPage />,
      },
      (data["69e866133634bde6f1b39c14"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c14"]?.access_edit === 1) && {
        path: `${RouterName.countries.createCountries}/:id?`,
        exact: true,
        element: <AddCountriesPage />,
      },
      data["69e866143634bde6f1b39c1d"]?.access_read === 1 && {
        path: `${RouterName.slideshow.slideshow}`,
        exact: true,
        element: <SlideShowPage />,
      },
      (data["69e866143634bde6f1b39c1d"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c1d"]?.access_edit === 1) && {
        path: `${RouterName.slideshow.createslideshow}/:id?`,
        exact: true,
        element: <AddSlideShowPage />,
      },

      data["69e866133634bde6f1b39c11"]?.access_read === 1 && {
        path: `${RouterName.services.services}`,
        exact: true,
        element: <ServicesPage />,
      },
      (data["69e866133634bde6f1b39c11"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c11"]?.access_edit === 1) && {
        path: `${RouterName.services.createServices}/:id?`,
        exact: true,
        element: <AddServicesPage />,
      },

      data["69e866143634bde6f1b39c20"]?.access_read === 1 && {
        path: `${RouterName.subservices.SubServices}`,
        exact: true,
        element: <SubServicesPage />,
      },
      (data["69e866143634bde6f1b39c20"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c20"]?.access_edit === 1) && {
        path: `${RouterName.subservices.createSubServices}/:id?`,
        exact: true,
        element: <AddSubServicesPage />,
      },

      data["69e866143634bde6f1b39c23"]?.access_read === 1 && {
        path: `${RouterName.subServicesMain.subServicesMain}`,
        exact: true,
        element: <SubServicesMainPage />,
      },
      (data["69e866143634bde6f1b39c23"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c23"]?.access_edit === 1) && {
        path: `${RouterName.subServicesMain.createSubServicesMain}/:id?`,
        exact: true,
        element: <AddSubServicesMainPage />,
      },

      data["69e866143634bde6f1b39c26"]?.access_read === 1 && {
        path: `${RouterName.subServicesListing.subServicesListing}`,
        exact: true,
        element: <SubServicesListingPage />,
      },
      (data["69e866143634bde6f1b39c26"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c26"]?.access_edit === 1) && {
        path: `${RouterName.subServicesListing.createSubServicesListing}/:id?`,
        exact: true,
        element: <AddSubServicesListingPage />,
      },

      data["69e866143634bde6f1b39c29"]?.access_read === 1 && {
        path: `${RouterName.industries.industries}`,
        exact: true,
        element: <IndustriesPage />,
      },
      (data["69e866143634bde6f1b39c29"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c29"]?.access_edit === 1) && {
        path: `${RouterName.industries.createIndustries}/:id?`,
        exact: true,
        element: <AddIndustriesPage />,
      },

      data["69e866143634bde6f1b39c2c"]?.access_read === 1 && {
        path: `${RouterName.industriesDetails.industriesDetails}`,
        exact: true,
        element: <IndustriesDetailsPage />,
      },
      (data["69e866143634bde6f1b39c2c"]?.access_write === 1 ||
        data["69e866143634bde6f1b39c2c"]?.access_edit === 1) && {
        path: `${RouterName.industriesDetails.createIndustriesDetails}/:id?`,
        exact: true,
        element: <AddIndustriesDetailsPage />,
      },

      data["69e866153634bde6f1b39c35"]?.access_read === 1 && {
        path: `${RouterName.nextLink.nextLink}`,
        exact: true,
        element: <NextLinkPage />,
      },
      (data["69e866153634bde6f1b39c35"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c35"]?.access_edit === 1) && {
        path: `${RouterName.nextLink.createNextLink}/:id?`,
        exact: true,
        element: <AddNextLinkPage />,
      },

      data["69e866153634bde6f1b39c3e"]?.access_read === 1 && {
        path: `${RouterName.trustedBy.trustedBy}`,
        exact: true,
        element: <TrustedByPage />,
      },
      (data["69e866153634bde6f1b39c3e"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c3e"]?.access_edit === 1) && {
        path: `${RouterName.trustedBy.createTrustedBy}/:id?`,
        exact: true,
        element: <AddTrustedByPage />,
      },

      data["69e866153634bde6f1b39c3b"]?.access_read === 1 && {
        path: `${RouterName.ourClients.ourClients}`,
        exact: true,
        element: <OurClientsPage />,
      },
      (data["69e866153634bde6f1b39c3b"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c3b"]?.access_edit === 1) && {
        path: `${RouterName.ourClients.createOurClients}/:id?`,
        exact: true,
        element: <AddOurClientsPage />,
      },

      data["69e866153634bde6f1b39c32"]?.access_read === 1 && {
        path: `${RouterName.news.news}`,
        exact: true,
        element: <NewsPage />,
      },
      (data["69e866153634bde6f1b39c32"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c32"]?.access_edit === 1) && {
        path: `${RouterName.news.createnNews}/:id?`,
        exact: true,
        element: <AddNewsPage />,
      },

      data["69e866153634bde6f1b39c38"]?.access_read === 1 && {
        path: `${RouterName.stats.stats}`,
        exact: true,
        element: <StatsInfoPage />,
      },
      (data["69e866153634bde6f1b39c38"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c38"]?.access_edit === 1) && {
        path: `${RouterName.stats.createStats}/:id?`,
        exact: true,
        element: <AddStats />,
      },
      ////////////////////////////////////
      data["6758084550a9707807cd62ca"]?.access_read === 1 && {
        path: `${RouterName.work.work}`,
        exact: true,
        element: <WorkDiversityPage />,
      },
      (data["6758084550a9707807cd62ca"]?.access_write === 1 ||
        data["6758084550a9707807cd62ca"]?.access_edit === 1) && {
        path: `${RouterName.work.createWork}/:id?`,
        exact: true,
        element: <AddWorkDiversityPage />,
      },
      ////////////////////////////////////

      data["69e866133634bde6f1b39c17"]?.access_read === 1 && {
        path: `${RouterName.projects.projects}`,
        exact: true,
        element: <CSRProjectsPage />,
      },
      (data["69e866133634bde6f1b39c17"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c17"]?.access_edit === 1) && {
        path: `${RouterName.projects.createProjects}/:id?`,
        exact: true,
        element: <AddCSRProjectsPage />,
      },

      data["69e866153634bde6f1b39c2f"]?.access_read === 1 && {
        path: `${RouterName.values.values}`,
        exact: true,
        element: <ValuesPage />,
      },
      (data["69e866153634bde6f1b39c2f"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c2f"]?.access_edit === 1) && {
        path: `${RouterName.values.createValues}/:id?`,
        exact: true,
        element: <AddValuesPage />,
      },

      data["69e866153634bde6f1b39c2f"]?.access_read === 1 && {
        path: `${RouterName.awards.awards}`,
        exact: true,
        element: <ViewAwardsPage />,
      },
      (data["69e866153634bde6f1b39c2f"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c2f"]?.access_edit === 1) && {
        path: `${RouterName.awards.createAwards}/:id?`,
        exact: true,
        element: <AddAwardsPage />,
      },

      (data["69e866153634bde6f1b39c2f"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c2f"]?.access_read === 1 ||
        data["69e866153634bde6f1b39c2f"]?.access_edit === 1) && {
        path: `${RouterName.awards.awardsType}`,
        exact: true,
        element: <AwardsTypePage />,
      },
      data["69e866153634bde6f1b39c41"]?.access_read === 1 && {
        path: `${RouterName.seo.seo}`,
        exact: true,
        element: <SeoPage />,
      },

      (data["69e866153634bde6f1b39c41"]?.access_write === 1 ||
        data["69e866153634bde6f1b39c41"]?.access_edit === 1) && {
        path: `${RouterName.seo.createSeo}/:id?`,
        exact: true,
        element: <AddSeoPage />,
      },

      (data["69e866133634bde6f1b39c0b"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_edit === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_read === 1) && {
        path: `${RouterName.settings.createSettings}/:id?`,
        exact: true,
        element: <AddSettings />,
      },
      (data["69e866133634bde6f1b39c0b"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_edit === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_read === 1) && {
        path: `${RouterName.innovation.innovation}/:id?`,
        exact: true,
        element: <AddInnovation />,
      },

      (data["69e866133634bde6f1b39c0b"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_edit === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_read === 1) && {
        path: `${RouterName.about.about}/:id?`,
        exact: true,
        element: <AddAbout />,
      },

      (data["69e866133634bde6f1b39c0b"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_edit === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_read === 1) && {
        path: `${RouterName.ceo.ceo}/:id?`,
        exact: true,
        element: <AddCEO />,
      },

      (data["69e866133634bde6f1b39c0b"]?.access_write === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_edit === 1 ||
        data["69e866133634bde6f1b39c0b"]?.access_read === 1) && {
        path: `${RouterName.policies.policies}/:id?`,
        exact: true,
        element: <AddPolicies />,
      },

      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
